var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuitoSatisfeito(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 871,
    height: 871,
    viewBox: "0 0 871 871",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_70189)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_70189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 871,
    height: 871
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M870.858 0H0.00585938V870.852H870.858V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_70189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M767.034 434.053C767.034 617.952 617.954 767.031 434.057 767.031C250.159 767.031 101.08 617.952 101.08 434.053C101.08 250.155 250.159 101.076 434.057 101.076C617.954 101.076 767.034 250.155 767.034 434.053Z",
    fill: "url(#paint0_linear_14_70189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.949 435.309C728.381 602.84 593.421 736.613 429.504 734.1C265.59 731.586 134.791 593.744 137.359 426.213C139.928 258.681 274.888 124.91 438.804 127.422C602.718 129.935 733.517 267.78 730.949 435.309Z",
    fill: "url(#paint1_radial_14_70189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.034 434.053C767.034 617.952 617.954 767.031 434.057 767.031C250.159 767.031 101.08 617.952 101.08 434.053C101.08 250.155 250.159 101.076 434.057 101.076C617.954 101.076 767.034 250.155 767.034 434.053Z",
    stroke: "#E76900",
    strokeWidth: 10.3154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.639 350.065C599.364 351.391 597.156 350.979 596.48 349.269C591.227 335.998 570.699 293.11 525.284 294.846C470.155 296.953 450.334 354.841 464.84 400.168C479.871 447.134 508.044 481.563 545.575 522.005C547.787 524.39 551.159 525.325 554.287 524.429C573.775 518.843 644.013 497.109 681.864 464.064C726.1 425.446 725.396 367.868 695.692 345.4C668.643 324.939 625.372 324.352 600.639 350.065Z",
    fill: "#EFB724"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M590.842 343.335C591.189 344.877 592.995 345.559 594.253 344.603C604.029 337.188 638.229 314.81 670.84 336.322C710.427 362.436 699.201 413.821 668.34 440.676C636.364 468.503 600.315 481.258 554.706 494.264C552.016 495.032 549.12 494.215 547.22 492.163C535.383 479.373 493.436 432.101 480.337 390.944C465.027 342.844 491.199 300.834 523.046 297.552C552.048 294.565 584.117 313.412 590.842 343.335Z",
    fill: "#E80505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.012 332.499C588.735 340.382 598.576 343.32 606.82 339.257C620.948 332.292 642.216 326.738 662.791 340.309C698.948 364.16 686.387 407.434 658.2 431.963C657.493 432.577 656.786 433.183 656.075 433.781C599.69 481.281 517.243 462.329 492.563 392.856C492.17 391.749 491.798 390.645 491.448 389.547C477.464 345.615 498.707 307.894 527.797 304.897C549.328 302.678 572.715 313.64 584.012 332.499Z",
    fill: "url(#paint2_linear_14_70189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.842 343.335C591.189 344.877 592.995 345.559 594.253 344.603C604.029 337.188 638.229 314.81 670.84 336.322C710.427 362.436 699.201 413.821 668.34 440.676C636.364 468.503 600.315 481.259 554.706 494.264C552.016 495.032 549.12 494.215 547.22 492.163C535.383 479.373 493.436 432.101 480.337 390.944C465.027 342.844 491.199 300.834 523.046 297.552C552.048 294.565 584.117 313.412 590.842 343.335Z",
    stroke: "#BE0A25",
    strokeWidth: 10.3009,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.83 350.067C268.105 351.393 270.312 350.981 270.989 349.272C276.243 336.001 296.775 293.116 342.191 294.856C397.321 296.968 417.137 354.856 402.627 400.181C387.592 447.145 359.415 481.57 321.88 522.008C319.667 524.393 316.296 525.328 313.168 524.432C293.68 518.844 223.442 497.104 185.593 464.057C141.36 425.436 142.069 367.859 171.775 345.394C198.826 324.935 242.098 324.353 266.83 350.067Z",
    fill: "#EFB724"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276.628 343.338C276.282 344.88 274.475 345.561 273.217 344.605C263.441 337.19 229.243 314.809 196.629 336.318C157.039 362.428 168.261 413.812 199.12 440.67C231.094 468.499 267.143 481.258 312.752 494.267C315.442 495.035 318.338 494.218 320.238 492.166C332.076 479.378 374.028 432.11 387.131 390.955C402.446 342.858 376.277 300.846 344.429 297.562C315.428 294.572 283.356 313.416 276.628 343.338Z",
    fill: "#E80505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.464 332.504C278.74 340.386 268.899 343.323 260.655 339.26C246.527 332.293 225.259 326.738 204.683 340.306C168.523 364.154 181.081 407.428 209.266 431.959C209.973 432.573 210.68 433.179 211.391 433.778C267.773 481.281 350.223 462.336 374.91 392.868C375.303 391.76 375.675 390.656 376.025 389.559C390.013 345.628 368.773 307.907 339.683 304.907C318.151 302.686 294.763 313.646 283.464 332.504Z",
    fill: "url(#paint3_linear_14_70189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.628 343.338C276.282 344.88 274.475 345.561 273.217 344.605C263.441 337.19 229.243 314.809 196.629 336.318C157.039 362.428 168.261 413.812 199.12 440.67C231.094 468.499 267.143 481.258 312.752 494.267C315.442 495.035 318.338 494.218 320.238 492.166C332.076 479.378 374.028 432.11 387.131 390.955C402.446 342.858 376.277 300.846 344.429 297.562C315.428 294.572 283.356 313.416 276.628 343.338Z",
    stroke: "#BE0A25",
    strokeWidth: 10.3009,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.303 573.856C604.628 631.411 531.645 707.232 434.232 707.232C336.82 707.232 267.142 641.003 255.39 575.093C255.279 574.472 255.235 572.646 255.228 572.094C255.119 564.186 257.645 558.406 265.03 558.979C283.745 560.429 331.399 580.669 434.232 582.343C541.788 580.591 587.48 559.151 604.441 559.033C610.096 558.994 613.337 563.733 613.235 572.094C613.227 572.646 613.396 573.231 613.303 573.856Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.542 584.721C602.867 642.276 531.644 712.676 434.231 712.676C336.819 712.676 268.902 651.868 257.15 585.958C257.039 585.337 256.995 583.51 256.988 582.957C256.879 575.049 257.644 569.27 265.029 569.842C283.744 571.292 331.399 593.292 434.231 594.966C541.787 593.215 587.479 570.016 604.441 569.898C610.095 569.859 611.576 574.597 611.473 582.957C611.466 583.51 611.635 584.096 611.542 584.721Z",
    fill: "#FEDD78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.433 576.745C609.433 576.886 609.416 577.045 609.381 577.203C606.775 594.508 598.22 612.834 584.858 629.927C554.755 668.445 500.235 700.678 434.237 700.678C368.767 700.678 316.008 672.829 285.658 634.469C285.64 634.452 285.621 634.434 285.603 634.399C272.506 617.833 263.6 599.296 259.657 580.213C259.445 579.21 259.252 578.206 259.076 577.203C259.005 576.798 259.041 576.428 259.076 576.059C259.093 575.971 259.093 575.865 259.111 575.759C259.129 575.671 259.146 575.566 259.146 575.478C259.164 575.231 259.199 574.985 259.217 574.756C259.322 574.052 259.461 573.436 259.673 572.908C259.743 572.714 259.815 572.538 259.903 572.379C260.079 572.063 260.273 571.763 260.484 571.517C260.59 571.394 260.713 571.27 260.836 571.147C269.128 563.63 309.054 591.198 434.237 593.24C574.507 590.952 607.743 556.606 609.328 575.478C609.345 575.689 609.363 575.918 609.381 576.129C609.416 576.34 609.433 576.534 609.433 576.745Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.433 576.745C609.433 576.886 609.416 577.045 609.381 577.203C606.775 594.508 598.22 612.834 584.858 629.927C590.949 619.206 595.561 607.605 597.093 597.448C597.199 596.884 597.075 596.356 597.04 595.881C595.614 578.717 561.849 609.964 434.237 612.042C306.607 609.964 272.842 578.717 271.416 595.881C271.363 596.356 271.24 596.884 271.346 597.448C273.511 609.559 278.896 622.745 285.603 634.399C272.506 617.833 263.6 599.296 259.657 580.213C259.445 579.21 259.252 578.206 259.076 577.203C259.005 576.798 259.041 576.428 259.076 576.059C259.093 575.971 259.093 575.865 259.111 575.759C259.129 575.654 259.129 575.566 259.129 575.478C259.146 575.231 259.181 574.985 259.217 574.756C259.305 574.052 259.461 573.436 259.673 572.908C259.743 572.714 259.815 572.538 259.903 572.379C260.079 572.063 260.273 571.763 260.484 571.517C260.59 571.394 260.713 571.27 260.836 571.147C269.128 563.63 309.054 591.198 434.237 593.24C574.507 590.952 607.743 556.606 609.328 575.478C609.345 575.689 609.363 575.918 609.381 576.129C609.416 576.34 609.433 576.534 609.433 576.745Z",
    fill: "#632900"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_70189",
    x1: 432.281,
    y1: 130.954,
    x2: 435.697,
    y2: 757.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5AB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ED8700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14_70189",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.84 157.335) scale(585.148 585.148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FEFEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDEE8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCDE36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F5B820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE910A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_70189",
    x1: 586.605,
    y1: 365.732,
    x2: 598.743,
    y2: 324.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF988F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_70189",
    x1: 280.868,
    y1: 365.736,
    x2: 268.735,
    y2: 324.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF988F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_70189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 870.852,
    height: 870.852,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuitoSatisfeito);
export default __webpack_public_path__ + "static/media/muito-satisfeito.16be52e7f411a4dae61a4e32d20ed619.svg";
export { ForwardRef as ReactComponent };